/* MAMEIDO Warenkorb-Belohnungen: Fortschrittsbalken + Gratisartikel-Auswahl im Cart-Drawer.
   Markup: snippets/mameido-cart-rewards.liquid und snippets/mameido-cart-gifts.liquid
   Styles: assets/mameido-cart-rewards.css */
(function () {
  'use strict';

  var root = document.querySelector('[data-mcr]');
  if (!root) return;

  var STORAGE_KEY = 'mameido_cart_region';
  var GIFT_PROPERTY = '_mcr_gift';
  var UPSELL_MAX = 20;

  function euros(value, fallback) {
    var n = parseFloat(String(value).replace(',', '.'));
    return Math.round((isFinite(n) && n > 0 ? n : fallback) * 100);
  }

  var REGIONS = {
    DE: { ship: euros(root.dataset.shipDe, 59), gift: euros(root.dataset.giftDe, 99), fee: euros(root.dataset.feeDe, 3.99) },
    EU: { ship: euros(root.dataset.shipEu, 89), gift: euros(root.dataset.giftEu, 99), fee: euros(root.dataset.feeEu, 9.9) }
  };

  var els = {
    text: root.querySelector('[data-mcr-text]'),
    bar: root.querySelector('[data-mcr-bar]'),
    fill: root.querySelector('[data-mcr-fill]'),
    shipMarker: root.querySelector('[data-mcr-marker="ship"]'),
    giftMarker: root.querySelector('[data-mcr-marker="gift"]'),
    shipAmount: root.querySelector('[data-mcr-amount="ship"]'),
    giftAmount: root.querySelector('[data-mcr-amount="gift"]'),
    mergeWrap: root.querySelector('.mcr__merge'),
    mergeAmount: root.querySelector('[data-mcr-amount="ship-merge"]'),
    pills: document.querySelectorAll('#CartDrawer [data-region]')
  };

  var gifts = {
    panel: document.querySelector('[data-mcg]'),
    list: document.querySelector('[data-mcg-list]'),
    error: document.querySelector('[data-mcg-error]')
  };

  var upsell = {
    panel: document.querySelector('[data-mcu]'),
    list: document.querySelector('[data-mcu-list]')
  };

  var region = readRegion() || root.dataset.defaultRegion || 'DE';
  if (!REGIONS[region]) region = 'DE';

  var lastCart = null;
  var previous = null;
  var requestId = 0;
  var timer = null;
  var busy = false;

  function readRegion() {
    try {
      var stored = window.localStorage.getItem(STORAGE_KEY);
      return REGIONS[stored] ? stored : null;
    } catch (e) {
      return null;
    }
  }

  function storeRegion(value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {}
  }

  function money(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var whole = cents % 100 === 0;
    try {
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(whole ? 0 : 2) + ' €';
    }
  }

  function routeUrl(path) {
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return base + path;
  }

  function isGiftLine(item) {
    return !!(item.properties && item.properties[GIFT_PROPERTY]);
  }

  // Alles Bezahlte zaehlt (inkl. Gravur-Zeilen), nur das Geschenk selbst nicht.
  function qualifyingTotal(cart) {
    if (!cart || !cart.items) return 0;
    return cart.items.reduce(function (sum, item) {
      return sum + (isGiftLine(item) ? 0 : item.final_line_price);
    }, 0);
  }

  // Handy: eine kurze Variante in einer Zeile (Klasse mcr-short), sonst der ausführliche Text (mcr-long).
  function both(long, short) {
    return '<span class="mcr-long">' + long + '</span><span class="mcr-short">' + short + '</span>';
  }

  // Texte aus Theme-Einstellungen > Warenkorb (MAMEIDO): {betrag} wird durch den Betrag ersetzt.
  function tpl(text, amountHtml) {
    return String(text).replace(/{betrag}/g, amountHtml);
  }

  function message(stage, hasGift, missing, giftChosen) {
    var amount = '<strong>' + money(missing) + '</strong>';
    if (stage === 'ship' && root.dataset.msgShip) return tpl(root.dataset.msgShip, amount);
    if (stage === 'gift' && root.dataset.msgGift) return tpl(root.dataset.msgGift, amount);
    if (stage === 'done' && !hasGift && root.dataset.msgDone) return tpl(root.dataset.msgDone, amount);
    if (stage === 'done' && hasGift && !giftChosen && root.dataset.msgPick) return tpl(root.dataset.msgPick, amount);
    if (stage === 'done' && hasGift && giftChosen && root.dataset.msgDoneGift) return tpl(root.dataset.msgDoneGift, amount);
    var shipFree = 'Deine Sendung ist <strong>versandkostenfrei</strong>';
    if (stage === 'ship') {
      return 'Noch ' + amount + ' bis zum <strong>Gratisversand</strong>';
    }
    if (stage === 'gift') {
      return both(
        shipFree + '! Noch ' + amount + ' bis zu deinem <strong>Gratisprodukt</strong>',
        'Noch ' + amount + ' bis zum <strong>Gratisprodukt</strong>'
      );
    }
    if (!hasGift) {
      return shipFree + '!';
    }
    return giftChosen
      ? both(
        shipFree + ' und dein <strong>Gratisprodukt</strong> ist dabei!',
        '<strong>Gratisversand</strong> + <strong>Gratisprodukt</strong> dabei!'
      )
      : both(
        shipFree + '! Wähle jetzt dein <strong>Gratisprodukt</strong>',
        '<strong>Versandkostenfrei!</strong> Wähle dein Geschenk'
      );
  }

  /* ---------- Gratisartikel ---------- */

  function giftCards() {
    return gifts.list ? Array.prototype.slice.call(gifts.list.querySelectorAll('[data-mcg-item]')) : [];
  }

  var giftErrorTimer = null;
  function showGiftError(text) {
    if (!gifts.error) return;
    window.clearTimeout(giftErrorTimer);
    gifts.error.textContent = text || '';
    gifts.error.hidden = !text;
    if (text) {
      giftErrorTimer = window.setTimeout(function () { gifts.error.hidden = true; }, 5000);
    }
  }

  // Ein Artikel aus der Gratisartikel-Liste, der ganz normal im Warenkorb liegt und vom Rabatt gratis
  // gemacht wurde: Er ist dann bereits der Gratisartikel dieser Bestellung.
  function freeListLine(cart) {
    var listIds = giftCards().map(function (card) { return card.dataset.variantId; });
    return cart.items.some(function (item) {
      return !isGiftLine(item) &&
        listIds.indexOf(String(item.variant_id)) !== -1 &&
        item.final_line_price < item.original_line_price;
    });
  }

  function renderGifts(cart, open) {
    if (!gifts.panel) return;
    var cards = giftCards();
    var visible = open && cards.length > 0;    gifts.panel.hidden = !visible;
    if (!visible) {
      var giftScroller = gifts.panel.querySelector('[data-mcr-scroller]');
      if (giftScroller) giftScroller.mcrNudged = false;
      return;
    }

    var chosen = cart.items.filter(isGiftLine).map(function (line) { return String(line.variant_id); });
    var alreadyFree = freeListLine(cart);
    cards.forEach(function (card) {
      var selected = chosen.indexOf(card.dataset.variantId) !== -1;
      card.classList.toggle('is-selected', selected);
      card.classList.toggle('is-locked', (chosen.length > 0 || alreadyFree) && !selected);
      var label = card.querySelector('.mcg__btn-text');
      var plus = card.querySelector('.mcg__btn-plus');
      if (label) label.textContent = selected ? 'Entfernen' : 'Auswählen';
    });
  }

  /* ---------- Bestseller-Streifen ---------- */

  // Zufaellige Reihenfolge pro Seitenaufruf; gleiche Produkte moeglichst nicht direkt hintereinander.
  // Gilt fuer die Bestseller-Karten und die Gratisartikel-Karten (je data-product-id).
  function shuffleList(list, itemSelector) {
    if (!list) return;
    var cards = Array.prototype.slice.call(list.querySelectorAll(itemSelector));
    for (var i = cards.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var swap = cards[i];
      cards[i] = cards[j];
      cards[j] = swap;
    }

    // Nach Produkt gruppieren (die Karten sind schon gemischt, also auch innerhalb jeder Gruppe).
    var groups = {};
    cards.forEach(function (card) {
      var id = card.dataset.productId;
      (groups[id] = groups[id] || []).push(card);
    });
    var keys = Object.keys(groups);

    // Reihum auswählen: nie dasselbe Produkt wie zuvor, solange das möglich ist. Eine Gruppe, die mehr als die
    // Hälfte der restlichen Karten stellt, muss sofort dran, sonst ließe sie sich nicht mehr auflockern.
    var ordered = [];
    var last = null;
    var remaining = cards.length;
    while (remaining > 0) {
      var candidates = keys.filter(function (key) { return groups[key].length && key !== last; });
      var pick;
      if (!candidates.length) {
        pick = last;
      } else {
        var must = candidates.filter(function (key) { return groups[key].length * 2 > remaining; });
        if (must.length) {
          pick = must[0];
        } else {
          var total = candidates.reduce(function (sum, key) { return sum + groups[key].length; }, 0);
          var roll = Math.random() * total;
          pick = candidates[candidates.length - 1];
          for (var c = 0; c < candidates.length; c++) {
            roll -= groups[candidates[c]].length;
            if (roll < 0) { pick = candidates[c]; break; }
          }
        }
      }
      ordered.push(groups[pick].shift());
      last = pick;
      remaining--;
    }

    ordered.forEach(function (card) { list.appendChild(card); });
  }

  function shuffleUpsell() {
    shuffleList(upsell.list, '[data-mcu-item]');
  }

  function shuffleGifts() {
    shuffleList(gifts.list, '[data-mcg-item]');
  }

  // Cross-Sell: Alles, was als Produkt schon im Warenkorb liegt (egal welche Farbe oder Größe, auch das
  // gewählte Geschenk), wird nicht noch einmal vorgeschlagen.
  // Nach dem ersten Plus-Klick im Streifen verschwindet nur der Titel "Wird oft zusammen gekauft" (Klasse is-done), die Karten rücken nach links.
  // Das gilt für den Rest des Besuchs, bis der Warenkorb wieder leer ist.
  var UPSELL_DONE_KEY = 'mameido-upsell-done';
  function upsellDone() {
    try { return window.sessionStorage.getItem(UPSELL_DONE_KEY) === '1'; } catch (e) { return false; }
  }
  function setUpsellDone(value) {
    try {
      if (value) window.sessionStorage.setItem(UPSELL_DONE_KEY, '1');
      else window.sessionStorage.removeItem(UPSELL_DONE_KEY);
    } catch (e) {}
  }

  function renderUpsell(cart) {
    if (!upsell.panel || !upsell.list) return;
    if (cart.item_count === 0) setUpsellDone(false);
    var inCart = cart.items.map(function (item) { return String(item.product_id); });
    var visible = 0;
    Array.prototype.forEach.call(upsell.list.querySelectorAll('[data-mcu-item]'), function (card) {
      var hide = inCart.indexOf(card.dataset.productId) !== -1 || visible >= UPSELL_MAX;
      card.hidden = hide;
      if (!hide) visible++;
    });
    upsell.panel.hidden = cart.item_count === 0 || visible === 0;
    upsell.panel.classList.toggle('is-done', upsellDone());
  }

  function addUpsell(card) {
    if (busy) return;
    busy = true;
    card.classList.add('is-loading');
    expectCheck(card.dataset.variantId);
    setUpsellDone(true);
    confetti({ origin: card.querySelector('[data-mcu-add]') || card, count: 36, power: 0.7 });
    postJson('cart/add.js', { items: [{ id: Number(card.dataset.variantId), quantity: 1 }] })
      .then(function (response) {
        if (!response.ok && card.parentNode) card.parentNode.removeChild(card);
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        card.classList.remove('is-loading');
        rebuildDrawer();
      });
  }

  function postJson(path, body) {
    return fetch(routeUrl(path), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function rebuildDrawer() {
    document.dispatchEvent(new CustomEvent('cart:build'));
    refresh();
  }

  function removeGiftLines(lines) {
    return lines.reduce(function (chain, line) {
      return chain.then(function () { return postJson('cart/change.js', { id: line.key, quantity: 0 }); });
    }, Promise.resolve());
  }

  function selectGift(card) {
    if (busy || !lastCart) return;
    var variantId = card.dataset.variantId;
    var existing = lastCart.items.filter(isGiftLine);

    if (!existing.length && freeListLine(lastCart)) {
      showGiftError('In deinem Warenkorb liegt schon ein Artikel aus der Gratisprodukt-Auswahl, der ist dein Gratisprodukt.');
      return;
    }

    if (existing.length) {
      var isChosen = existing.some(function (line) { return String(line.variant_id) === variantId; });
      if (!isChosen) {
        showGiftError('Du hast bereits ein Gratisprodukt ausgewählt.');
        return;
      }
      // Tipp auf das gewaehlte Geschenk nimmt es wieder heraus, dann ist eine andere Wahl moeglich.
      cancelChecks();
      busy = true;
      showGiftError('');
      card.classList.add('is-loading');
      removeGiftLines(existing)
        .catch(function () {})
        .then(function () {
          busy = false;
          card.classList.remove('is-loading');
          rebuildDrawer();
        });
      return;
    }

    busy = true;
    showGiftError('');
    card.classList.add('is-loading');
    expectCheck(variantId);

    Promise.resolve()
      .then(function () {
        return postJson('cart/add.js', {
          items: [{ id: Number(variantId), quantity: 1, properties: (function () { var p = {}; p[GIFT_PROPERTY] = '1'; return p; })() }]
        });
      })
      .then(function (response) {
        if (!response.ok) {
          card.parentNode && card.parentNode.removeChild(card);
          showGiftError('Dieses Gratisprodukt ist leider gerade nicht mehr verfügbar. Bitte wähle ein anderes.');
        }
      })
      .catch(function () {
        showGiftError('Das hat leider nicht geklappt. Bitte versuche es noch einmal.');
      })
      .then(function () {
        busy = false;
        card.classList.remove('is-loading');
        rebuildDrawer();
      });
  }

  // Faellt der Warenkorbwert unter die Schwelle, wuerde das Geschenk sonst voll berechnet.
  function dropOrphanGifts(cart, total) {
    var lines = cart.items.filter(isGiftLine);
    var giftAt = REGIONS[region].gift;
    if (!lines.length || busy || (giftAt !== null && total >= giftAt)) return false;
    busy = true;
    removeGiftLines(lines).then(function () {
      busy = false;
      rebuildDrawer();
    }, function () {
      busy = false;
    });
    return true;
  }

  // Preis-Wächter: Ab der Gratisartikel-Grenze muss die Geschenk-Zeile 0 € kosten. Tut sie das nicht,
  // gibt es zwei Gründe, und in beiden Fällen nehmen wir sie heraus und sagen warum:
  //  1) Im Warenkorb liegt zusätzlich ein Listenartikel ganz normal; Shopify macht den günstigeren der beiden
  //     gratis, und das ist dann der normal gekaufte statt des gewählten.
  //  2) Der Rabatt greift gar nicht (nicht aktiv, Variante fehlt im Rabatt, Warenwert knapp darunter).
  // Vorschau-Modus (nicht veröffentlichtes Theme): Fall 2 wird übersprungen, solange es den Rabatt noch nicht
  // gibt, sonst würde die Vorschau-Anzeige "0,00€" jede Auswahl wieder entfernen.
  function guardGifts(cart, total) {
    if (busy) return false;
    var giftLines = cart.items.filter(isGiftLine);
    var giftAt = REGIONS[region].gift;
    if (!giftLines.length || giftAt === null || total < giftAt) return false;
    var paid = giftLines.filter(function (line) { return line.final_line_price > 0; });
    if (!paid.length) return false;

    var listIds = giftCards().map(function (card) { return card.dataset.variantId; });
    var otherFree = cart.items.some(function (item) {
      return !isGiftLine(item) &&
        listIds.indexOf(String(item.variant_id)) !== -1 &&
        item.final_line_price < item.original_line_price;
    });
    if (!otherFree && root.dataset.previewGift === 'true') return false;

    busy = true;
    removeGiftLines(paid).then(function () {
      busy = false;
      showGiftError(otherFree
        ? 'In deinem Warenkorb liegt schon ein Artikel aus der Gratisprodukt-Auswahl, der ist jetzt dein Gratisprodukt. Dein gewähltes Geschenk haben wir wieder herausgenommen.'
        : 'Dein Gratisprodukt konnte nicht gratis berechnet werden, zum Beispiel weil ein Rabattcode im Warenkorb mehr bringt. Code und Gratisprodukt lassen sich nicht kombinieren. Wähle es gern noch einmal oder melde dich bei uns.');
      rebuildDrawer();
    }, function () {
      busy = false;
    });
    return true;
  }

  /* ---------- Menge als Tippfeld (Handy: ohne Plus und Minus) ---------- */

  // Antippen markiert die Zahl, damit man gleich eine neue eintippen kann.
  document.addEventListener('focusin', function (event) {
    var input = event.target;
    if (!input.classList || !input.classList.contains('js-qty__num') || !input.closest('#CartDrawer')) return;
    window.setTimeout(function () { if (input.select) input.select(); }, 0);
  });

  // Im Warenkorb lässt sich nichts markieren, kopieren oder ausschneiden. Die Mengenfelder bleiben bedienbar.
  ['copy', 'cut', 'selectstart', 'dragstart'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var target = event.target && event.target.nodeType === 1 ? event.target : event.target && event.target.parentElement;
      if (!target || !target.closest || !target.closest('#CartDrawer')) return;
      if (target.closest('input, textarea')) return;
      event.preventDefault();
    }, true);
  });

  // Mengenfeld: die sichtbare Zahl liegt als eigenes Element über dem Auswahlfeld und folgt der Auswahl sofort
  document.addEventListener('change', function (event) {
    var sel = event.target;
    if (!sel || !sel.classList || !sel.classList.contains('mcd-qty')) return;
    var val = sel.parentElement && sel.parentElement.querySelector('.mcd-qty-val');
    if (val) val.textContent = sel.value;
  });

  // Mülleimer hinter jedem Produkt: setzt die Menge auf 0. Normale Zeilen laufen über das Mengenfeld (Theme-Logik,
  // Gravur zieht mit), Gratisartikel haben kein Feld und werden direkt entfernt.
  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('[data-mcr-remove]') : null;
    if (!btn || !btn.closest('#CartDrawer')) return;
    event.preventDefault();
    var row = btn.closest('.cart__item');
    if (!row) return;
    var input = row.querySelector('.js-qty__num');
    if (input) {
      input.value = '0';
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    if (busy) return;
    busy = true;
    postJson('cart/change.js', { id: row.dataset.key, quantity: 0 })
      .catch(function () {})
      .then(function () {
        busy = false;
        rebuildDrawer();
      });
  });

  // Enter übernimmt die Menge (das Feld verlassen löst die Änderung aus), schickt aber nicht den
  // Warenkorb-Formular-Knopf ab.
  document.addEventListener('keydown', function (event) {
    var input = event.target;
    if (event.key !== 'Enter' || !input.classList || !input.classList.contains('js-qty__num') || !input.closest('#CartDrawer')) return;
    event.preventDefault();
    input.blur();
  });

  /* ---------- Warenkorb-Symbol im Kopf mit Anzahl ---------- */

  // Anzahl aller Artikel inkl. Gratisartikel, ohne Gravur-Unterzeilen (_gr_parent).
  function renderCount(cart) {
    var count = 0;
    cart.items.forEach(function (item) {
      if (item.properties && item.properties._gr_parent) return;
      count += item.quantity;
    });
    var bubble = document.querySelector('#CartDrawer [data-mcr-count]');
    var sr = document.querySelector('#CartDrawer [data-mcr-count-sr]');
    if (bubble) {
      var changed = bubble.textContent !== String(count);
      bubble.textContent = count;
      bubble.hidden = count === 0;
      if (changed && count > 0) {
        bubble.classList.remove('is-bump');
        void bubble.offsetWidth;
        bubble.classList.add('is-bump');
      }
    }
    if (sr) sr.textContent = count + ' Artikel';
  }

  /* ---------- Haken über dem Produktbild, wenn ein Artikel hinzugefügt wurde ---------- */

  var CHECK_SVG = '<svg viewBox="0 0 52 52" focusable="false"><circle cx="26" cy="26" r="24"/><path d="M15 27l7.5 7.5L37 19.5"/></svg>';
  var seenQuantities = null;   // Zeilenschlüssel -> Menge beim letzten Render (null = noch kein Render)
  var pendingChecks = {};      // Zeilenschlüssel -> { expires, startedAt }
  var CHECK_DURATION = 1900;   // gleiche Dauer wie mcr-added-pop im CSS
  var qtyClickAt = 0;
  var expectedChecks = {};     // Varianten-ID -> Ablaufzeit: nur diese Varianten dürfen einen Haken bekommen (Bestseller-Karte, Gratisprodukt)

  // Alle noch laufenden oder wartenden Haken abbrechen (beim Entfernen, bei Mengenänderung und beim Abwählen des Geschenks),
  // sonst spielt der Neuaufbau des Warenkorbs die Haken kürzlich hinzugefügter Artikel noch einmal ab.
  function cancelChecks() {
    pendingChecks = {};
    expectedChecks = {};
    Array.prototype.forEach.call(document.querySelectorAll('#CartDrawer .mcr-added'), function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
  }

  // Mengen-Knöpfe im Warenkorb selbst sollen keinen Haken auslösen, nur "hinzugefügt" von außen.
  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    if (event.target.closest('#CartDrawer .js-qty__wrapper')) qtyClickAt = Date.now();
    if (event.target.closest('#CartDrawer .js-qty__wrapper, #CartDrawer .cart__trash, #CartDrawer .cart__remove, #CartDrawer [data-mcr-remove]')) cancelChecks();
  }, true);
  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest && event.target.closest('#CartDrawer .js-qty__num')) cancelChecks();
  }, true);

  // Wird von addUpsell (Bestseller-Karte) und selectGift (Gratisprodukt) aufgerufen, bevor das Produkt in den Warenkorb kommt.
  function expectCheck(variantId) {
    expectedChecks[String(variantId)] = Date.now() + 10000;
  }

  // Haken gibt es nur, wenn ein Artikel über eine Bestseller-Karte oder das Gratisprodukt hinzugekommen ist.
  // Entfernen, Mengenänderung, Neuaufbau des Warenkorbs und alles andere lösen keinen Haken aus.
  function trackAdded(cart) {
    var next = {};
    cart.items.forEach(function (item) { next[item.key] = item.quantity; });
    var now = Date.now();
    Object.keys(expectedChecks).forEach(function (id) {
      if (expectedChecks[id] < now) delete expectedChecks[id];
    });
    if (seenQuantities) {
      cart.items.forEach(function (item) {
        var id = String(item.variant_id);
        if (!expectedChecks[id]) return;
        var before = seenQuantities[item.key] || 0;
        if (item.quantity > before) {
          pendingChecks[item.key] = { expires: now + 8000, startedAt: 0 };
          delete expectedChecks[id];
        }
      });
    }
    seenQuantities = next;
  }

  // Der Haken erscheint erst, wenn der Warenkorb offen ist und die Zeile im Warenkorb steht.
  // Das Theme baut die Zeilen nach dem Öffnen teils noch einmal neu auf: Geht der Haken dabei
  // verloren, wird er an der neuen Zeile an derselben Stelle der Animation fortgesetzt.
  function showAddedChecks() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || !drawer.classList.contains('drawer--is-open')) return;
    Object.keys(pendingChecks).forEach(function (key) {
      var entry = pendingChecks[key];
      var elapsed = entry.startedAt ? Date.now() - entry.startedAt : 0;
      if (entry.expires < Date.now() || elapsed >= CHECK_DURATION) {
        delete pendingChecks[key];
        return;
      }
      var row = Array.prototype.filter.call(drawer.querySelectorAll('.cart__item[data-key]'), function (el) {
        return el.getAttribute('data-key') === key;
      })[0];
      var image = row && row.querySelector('.cart__image');
      if (!image || image.querySelector('.mcr-added')) return;
      if (!entry.startedAt) entry.startedAt = Date.now();
      var badge = document.createElement('span');
      badge.className = 'mcr-added';
      badge.setAttribute('aria-hidden', 'true');
      badge.innerHTML = CHECK_SVG;
      var svg = badge.firstChild;
      svg.style.animationDelay = '-' + elapsed + 'ms';
      svg.querySelector('path').style.animationDelay = (250 - elapsed) + 'ms';
      image.appendChild(badge);
      // Die Animationen laufen am Haken-SVG; danach das Element wieder entfernen.
      badge.addEventListener('animationend', function (event) {
        if (event.animationName !== 'mcr-added-pop' && event.animationName !== 'mcr-added-fade') return;
        delete pendingChecks[key];
        if (badge.parentNode) badge.parentNode.removeChild(badge);
      });
    });
  }

  /* ---------- Gesamtersparnis ("Du sparst insgesamt") ---------- */

  // Die Ersparnis setzt sich aus drei Teilen zusammen und wird aufgeschlüsselt angezeigt:
  //   Versand        gesparte Versandkosten, sobald die Gratisversand-Grenze der Region erreicht ist
  //   Gratisartikel  Wert der Gratisartikel-Zeile, soweit sie tatsächlich 0 € kostet (Rabatt greift)
  //   Rabatte        Streichpreise und alle übrigen automatischen Rabatte
  // Rabatte + Gratisartikel kommen aus templates/cart.ajax.liquid (data-cart-savings, in Cent).
  function renderSavings(cart, shippingFree) {
    var box = document.querySelector('#CartDrawer [data-mcr-savings]');
    var amountEl = box && box.querySelector('[data-mcr-savings-amount]');
    var detailEl = box && box.querySelector('[data-mcr-savings-detail]');
    if (!amountEl) return;

    var items = document.querySelector('#CartDrawer .cart__items');
    var discounts = items ? parseInt(items.dataset.cartSavings, 10) || 0 : 0;
    var realGift = 0;      // vom Rabatt tatsächlich erlassen
    var previewGift = 0;   // nur Vorschau-Modus (nicht veröffentlichtes Theme): was der Rabatt noch erlassen würde
    cart.items.forEach(function (item) {
      if (!isGiftLine(item)) return;
      realGift += Math.max(0, item.original_line_price - item.final_line_price);
      if (root.dataset.previewGift === 'true') previewGift += item.final_line_price;
    });
    realGift = Math.min(realGift, discounts);
    var gift = realGift + previewGift;
    var other = discounts - realGift;
    var shipping = shippingFree && cart.items.length ? REGIONS[region].fee : 0;

    var total = shipping + gift + other;
    if (total < 1) {
      box.hidden = true;
      return;
    }

    var parts = [];
    if (shipping) parts.push('Versand ' + money(shipping));
    if (gift) parts.push('Gratisprodukt ' + money(gift));
    if (other) parts.push('Rabatte ' + money(other));
    amountEl.textContent = money(total);
    var textEl = box.querySelector('[data-mcr-savings-text]');
    if (textEl && box.dataset.tpl) textEl.innerHTML = tpl(box.dataset.tpl.replace(/&/g, '&amp;').replace(/</g, '&lt;'), '<strong>' + money(total) + '</strong>');
    if (detailEl) detailEl.textContent = parts.length > 1 && box.dataset.showDetail === 'true' ? parts.join(' · ') : '';
    box.hidden = false;
  }

  /* ---------- Balken ---------- */

  function render(cart) {
    lastCart = cart;
    var config = REGIONS[region];
    var hasGift = config.gift !== null;
    var total = qualifyingTotal(cart);

    if (dropOrphanGifts(cart, total)) return;
    if (guardGifts(cart, total)) return;

        var reached = { ship: total >= config.ship, gift: hasGift && total >= config.gift };
    var giftChosen = cart.items.some(isGiftLine) || (reached.gift && freeListLine(cart));

    var stage = 'ship';
    var missing = config.ship - total;
    if (reached.ship && hasGift && !reached.gift) {
      stage = 'gift';
      missing = config.gift - total;
    } else if (reached.ship && (!hasGift || reached.gift)) {
      stage = 'done';
      missing = 0;
    }

    // Die Marken stehen fest: Gratisversand in der Mitte, Gratisprodukt ganz rechts (ohne Gratisprodukt: Gratisversand am Ende).
    // Der Balken füllt jede Hälfte für sich, so bleibt die Mitte immer genau beim Gratisversand-Betrag.
    var percent;
    if (!hasGift) {
      percent = (total / config.ship) * 100;
    } else if (total < config.ship) {
      percent = (total / config.ship) * 50;
    } else {
      percent = 50 + ((total - config.ship) / (config.gift - config.ship)) * 50;
    }
    percent = Math.max(0, Math.min(100, percent));
    els.fill.style.width = percent + '%';
    els.bar.setAttribute('aria-valuenow', String(Math.round(percent)));
    root.dataset.stage = stage;
    els.text.innerHTML = message(stage, hasGift, missing, giftChosen);
    fitBanner(false);

    var shipPercent = hasGift ? 50 : 100;
    els.shipAmount.textContent = money(config.ship);
    els.shipMarker.style.left = shipPercent + '%';
    var merged = false;
    els.shipMarker.classList.toggle('is-end', !hasGift);
    els.shipMarker.classList.remove('is-late');
    els.shipMarker.classList.toggle('is-merged', merged);
    els.shipMarker.classList.toggle('is-reached', reached.ship);
    if (els.mergeWrap) {
      els.mergeWrap.hidden = !merged;
      if (els.mergeAmount) els.mergeAmount.textContent = money(config.ship);
    }

    els.giftMarker.hidden = !hasGift;
    if (hasGift) {
      els.giftAmount.textContent = money(config.gift);
      els.giftMarker.style.left = '100%';
      els.giftMarker.classList.add('is-end');
      els.giftMarker.classList.toggle('is-reached', reached.gift);
    }

    els.pills.forEach(function (pill) {
      pill.setAttribute('aria-pressed', String(pill.dataset.region === region));
    });

    var btnPrice = document.querySelector('#CartDrawer [data-mcd-btn-price]');
    if (btnPrice) btnPrice.textContent = money(cart.total_price);
    // Zeiger des Hinweisbands: zeigt auf die Marke, die als Nächstes erreicht wird (0,5 = Gratisversand in der Mitte, 1 = Ende)
    root.style.setProperty('--mcr-ptr', String(stage === 'gift' ? 1 : (hasGift ? 0.5 : 1)));

    renderGifts(cart, reached.gift);
    renderUpsell(cart);
    renderCount(cart);
    renderSavings(cart, reached.ship);
    trackAdded(cart);
    showAddedChecks();
    afterRender();

    var giftJustUnlocked = previous && previous.region === region && !previous.gift && reached.gift;
    var crossedUp = previous && previous.region === region &&
      ((!previous.ship && reached.ship) || giftJustUnlocked);
    if (crossedUp) confetti();
    if (giftJustUnlocked) scrollDrawerToTop();
    previous = { region: region, ship: reached.ship, gift: reached.gift };
  }

  function scrollDrawerToTop() {
    var scroller = document.querySelector('#CartDrawer .drawer__scrollable');
    if (scroller && scroller.scrollTo) scroller.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function fetchCart() {
    var id = ++requestId;
    return fetch(routeUrl('cart.js?t=' + Date.now()), { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) { return id === requestId ? cart : null; });
  }

  function refresh() {
    if (timer) return;
    timer = setTimeout(function () {
      timer = null;
      fetchCart().then(function (cart) { if (cart) render(cart); }).catch(function () {});
    }, 60);
  }

  // opts.origin: Element, von dem aus es konfettiert (Standard: der Balken)
  // opts.count / opts.power: Menge und Wucht (Standard: grosser Ausbruch)
  function confetti(opts) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    opts = opts || {};

    var canvas = document.createElement('canvas');
    canvas.className = 'mcr-confetti';
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');

    var rect = (opts.origin || els.bar).getBoundingClientRect();
    var originX = rect.left + rect.width / 2;
    var originY = rect.top + rect.height / 2;
    var count = opts.count || 110;
    var power = opts.power || 1;
    var colors = ['#adafa7', '#1c1d1d', '#e9c46a', '#e76f51', '#8ecae6', '#f4a6c1'];
    var pieces = [];
    for (var i = 0; i < count; i++) {
      var angle = Math.random() * Math.PI * 2;
      var speed = (4 + Math.random() * 8) * power;
      pieces.push({
        x: originX,
        y: originY,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed - 5,
        size: 5 + Math.random() * 6,
        rotation: Math.random() * Math.PI,
        spin: (Math.random() - 0.5) * 0.4,
        color: colors[i % colors.length],
        life: 0
      });
    }

    var frames = 0;
    (function tick() {
      frames++;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      pieces.forEach(function (p) {
        p.life++;
        p.vy += 0.28;
        p.vx *= 0.99;
        p.x += p.vx;
        p.y += p.vy;
        p.rotation += p.spin;
        ctx.save();
        ctx.globalAlpha = Math.max(0, 1 - p.life / 110);
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rotation);
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2);
        ctx.restore();
      });
      if (frames < 115) {
        window.requestAnimationFrame(tick);
      } else if (canvas.parentNode) {
        canvas.parentNode.removeChild(canvas);
      }
    })();
  }

  /* ---------- Events ---------- */

  els.pills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      var next = pill.dataset.region;
      if (!REGIONS[next] || next === region) return;
      region = next;
      storeRegion(region);
      previous = null;
      if (lastCart) render(lastCart); else refresh();
    });
  });

  if (gifts.list) {
    // Ganze Karte = auswählen/entfernen, nur das Bild öffnet das Produkt
    gifts.list.addEventListener('click', function (event) {
      if (event.target.closest('a')) return;
      var card = event.target.closest('[data-mcg-item]');
      if (card) selectGift(card);
    });
  }

  if (upsell.list) {
    // Ganze Karte = in den Warenkorb, nur das Bild öffnet das Produkt
    upsell.list.addEventListener('click', function (event) {
      if (event.target.closest('a')) return;
      var card = event.target.closest('[data-mcu-item]');
      if (card) addUpsell(card);
    });
  }

  /* ---------- Wisch-Listen: Pfeile am Rand und Hinweis zum Wischen ---------- */

  var scrollers = Array.prototype.slice.call(document.querySelectorAll('[data-mcr-scroller]'));

  function scrollList(list, direction) {
    if (!list) return;
    list.scrollBy({ left: direction * list.clientWidth * 0.8, behavior: 'smooth' });
  }

  function updateScroller(scroller) {
    var list = scroller.querySelector('ul');
    if (!list) return;
    var max = list.scrollWidth - list.clientWidth;
    scroller.classList.toggle('can-prev', list.scrollLeft > 6);
    scroller.classList.toggle('can-next', max > 6 && list.scrollLeft < max - 6);
  }

  function updateScrollers() {
    scrollers.forEach(updateScroller);
  }

  // Karten werden kurz angestupst, damit man sieht, dass man wischen kann (einmal pro Seitenaufruf
  // und Liste; beim Geschenk-Fenster bei jedem neuen Freischalten).
  function nudgeScroller(scroller) {
    if (scroller.getClientRects().length === 0) return false;
    updateScroller(scroller);
    if (!scroller.classList.contains('can-next')) return false;
    scroller.classList.add('is-nudging');
    window.setTimeout(function () { scroller.classList.remove('is-nudging'); }, 2000);
    return true;
  }

  function tryNudges() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || !drawer.classList.contains('drawer--is-open')) return;
    scrollers.forEach(function (scroller) {
      if (scroller.mcrNudged) return;
      if (nudgeScroller(scroller)) scroller.mcrNudged = true;
    });
  }

  // Bilder im Warenkorb sofort laden, auch fuer Zeilen, die erst weiter unten sichtbar werden.
  function loadCartImages() {
    Array.prototype.forEach.call(document.querySelectorAll('#CartDrawer .cart__image img'), function (img) {
      if (img.getAttribute('loading') !== 'eager') img.setAttribute('loading', 'eager');
    });
  }

  // Hinweisband: immer eine Zeile. Passt der Text nicht, wird die Schrift in 0,5-px-Schritten bis 9 px kleiner.
  var fitBox = null;
  var fitLast = '';
  function fitBanner(force) {
    var t = els.text;
    if (!t) return;
    var box = t.parentElement;
    if (!box || !box.clientWidth) return;
    var key = box.clientWidth + '|' + t.textContent;
    if (!force && key === fitLast) return;
    fitLast = key;
    t.style.fontSize = '';
    var fs = parseFloat(window.getComputedStyle(t).fontSize);
    var guard = 0;
    while (t.scrollWidth > t.clientWidth + 0.5 && fs > 9 && guard < 12) {
      fs -= 0.5;
      t.style.fontSize = fs + 'px';
      guard += 1;
    }
    if (!fitBox && window.ResizeObserver) {
      fitBox = new ResizeObserver(function () { fitBanner(false); });
      fitBox.observe(box);
    }
  }

  function afterRender() {
    loadCartImages();
    window.requestAnimationFrame(function () {
      updateScrollers();
      window.setTimeout(tryNudges, 350);
    });
  }

  scrollers.forEach(function (scroller) {
    var list = scroller.querySelector('ul');
    if (!list) return;
    list.addEventListener('scroll', function () { updateScroller(scroller); }, { passive: true });
    scroller.addEventListener('click', function (event) {
      var arrow = event.target.closest('[data-mcr-arrow]');
      if (arrow) scrollList(list, parseInt(arrow.dataset.mcrArrow, 10));
    });
  });

  window.addEventListener('resize', updateScrollers);
  document.addEventListener('drawerOpen', function () {
    window.setTimeout(function () { updateScrollers(); tryNudges(); }, 700);
  });

  /* ---------- Grosser Schliessen-Kreis auf dem Milchglas (nur Maus) ---------- */

  var drawerEl = document.getElementById('CartDrawer');
  var pageEl = document.getElementById('PageContainer');
  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (finePointer && drawerEl && pageEl) {
    var closeCursor = document.createElement('div');
    closeCursor.className = 'mcr-close';
    closeCursor.setAttribute('aria-hidden', 'true');
    closeCursor.innerHTML = '<svg viewBox="0 0 28 28" focusable="false"><path d="M7 7l14 14M21 7L7 21"/></svg>';
    document.body.appendChild(closeCursor);

    var cartIsOpen = function () { return drawerEl.classList.contains('drawer--is-open'); };
    var isGlass = function (target) {
      return cartIsOpen() && target instanceof Element && pageEl.contains(target) && !drawerEl.contains(target);
    };
    var setGlassHover = function (on) {
      closeCursor.classList.toggle('is-visible', on);
      document.documentElement.classList.toggle('mcr-glass-hover', on);
    };

    document.addEventListener('mousemove', function (event) {
      var on = isGlass(event.target);
      if (on) {
        var half = closeCursor.offsetWidth / 2;
        closeCursor.style.transform = 'translate(' + (event.clientX - half) + 'px,' + (event.clientY - half) + 'px)';
      }
      setGlassHover(on);
    }, { passive: true });

    document.addEventListener('mouseleave', function () { setGlassHover(false); });

    // Klick auf das Milchglas schliesst den Warenkorb, statt einen Link darunter zu oeffnen.
    document.addEventListener('click', function (event) {
      if (!isGlass(event.target)) return;
      event.preventDefault();
      event.stopPropagation();
      setGlassHover(false);
      document.dispatchEvent(new CustomEvent('cart:close'));
    }, true);

    if ('MutationObserver' in window) {
      new MutationObserver(function () { if (!cartIsOpen()) setGlassHover(false); })
        .observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
    }
  }

  ['cart:updated', 'cart:build', 'cart:open', 'drawerOpen'].forEach(function (name) {
    document.addEventListener(name, refresh);
  });

  var products = document.querySelector('#CartDrawer [data-products]');
  if (products && 'MutationObserver' in window) {
    new MutationObserver(refresh).observe(products, { childList: true });
  }

  shuffleUpsell();
  shuffleGifts();
  fetchCart().then(function (cart) { if (cart) render(cart); }).catch(function () {});
  /* ---------- Leerzeichen vor dem Euro-Zeichen (nur im Warenkorb) ---------- */

  // Der Shop liefert Preise als "5,99€" (Währungsformat im Admin). Im Warenkorb wird daraus "5,99 €" (geschütztes
  // Leerzeichen, damit der Preis nie vor dem Euro-Zeichen umbricht). Die Beobachter-Funktion läuft, bevor der Browser
  // zeichnet, deshalb flackert nichts, auch wenn das Theme Preise nachträglich neu schreibt.
  var euroPattern = /(\d)\u20ac/g;
  var fixingEuro = false;

  function spaceEuro(scope) {
    if (fixingEuro || !scope) return;
    fixingEuro = true;
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
    var node;
    var nodes = [];
    while ((node = walker.nextNode())) {
      if (/\d\u20ac/.test(node.nodeValue)) nodes.push(node);
    }
    nodes.forEach(function (textNode) {
      textNode.nodeValue = textNode.nodeValue.replace(euroPattern, '$1 €');
    });
    fixingEuro = false;
  }

  var drawerEl = document.getElementById('CartDrawer');
  if (drawerEl && window.MutationObserver) {
    spaceEuro(drawerEl);
    new MutationObserver(function () { spaceEuro(drawerEl); })
      .observe(drawerEl, { childList: true, subtree: true, characterData: true });
  }
})();
